import React from 'react';
import { CheckCircle } from 'lucide-react';

function About() {
  return (
    <div className="min-h-screen bg-[#f0efe9] dark:bg-gray-900">
      {/* Hero Section */}
      <div className="py-20 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-light text-gray-800 dark:text-white mb-6">About Aussi Clean</h1>
            <div className="w-24 h-0.5 bg-gray-400 dark:bg-gray-600 mx-auto mb-8"></div>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              Your trusted partner in professional cleaning services
            </p>
          </div>
        </div>
      </div>

      {/* Our Story */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            <div>
              <h2 className="text-3xl font-light text-gray-800 dark:text-white mb-6">Our Story</h2>
              <div className="w-12 h-0.5 bg-gray-400 dark:bg-gray-600 mb-8"></div>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Founded with a passion for cleanliness and attention to detail, Aussi Clean has grown to become a trusted name in professional cleaning services throughout Maryland, DC, and Northern Virginia.
              </p>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Our journey began with a simple mission: to provide exceptional cleaning services that exceed our clients' expectations. Today, we continue to uphold that mission with every home and business we service.
              </p>
              <p className="text-gray-600 dark:text-gray-300">
                We believe that a clean environment is essential for both physical and mental well-being. That's why we've dedicated ourselves to providing top-notch cleaning services that not only meet but exceed our clients' expectations.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <img 
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=80" 
                alt="Clean home interior" 
                className="w-full max-w-md h-auto border border-gray-200 dark:border-gray-700"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-light text-gray-800 dark:text-white mb-4">Our Values</h2>
            <div className="w-24 h-0.5 bg-gray-400 dark:bg-gray-600 mx-auto mb-8"></div>
            <p className="text-gray-600 dark:text-gray-300">
              The principles that guide our work and relationships
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-2">Quality</h3>
              <div className="w-12 h-0.5 bg-gray-400 dark:bg-gray-600 mb-4"></div>
              <p className="text-gray-600 dark:text-gray-300">
                We are committed to delivering the highest quality cleaning services. Our attention to detail ensures that every corner of your space receives the care it deserves.
              </p>
            </div>
            
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-2">Reliability</h3>
              <div className="w-12 h-0.5 bg-gray-400 dark:bg-gray-600 mb-4"></div>
              <p className="text-gray-600 dark:text-gray-300">
                You can count on us to show up on time, every time. We understand the importance of reliability and strive to be a cleaning service you can depend on.
              </p>
            </div>
            
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-2">Integrity</h3>
              <div className="w-12 h-0.5 bg-gray-400 dark:bg-gray-600 mb-4"></div>
              <p className="text-gray-600 dark:text-gray-300">
                We operate with honesty and transparency in all our dealings. Our pricing is straightforward, and we always deliver on our promises.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-light text-gray-800 dark:text-white mb-4">Why Choose Us</h2>
            <div className="w-24 h-0.5 bg-gray-400 dark:bg-gray-600 mx-auto mb-8"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-4">Professional Staff</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Trained and experienced cleaners</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Background checked for your security</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Attention to detail on every job</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Professional and courteous service</span>
                </li>
              </ul>
            </div>
            
            <div className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-4">Quality Service</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Consistent, reliable cleaning</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">High-quality cleaning products</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">Eco-friendly options available</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 dark:text-gray-300">100% satisfaction guarantee</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-20 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-light text-gray-800 dark:text-white mb-4">Our Service Area</h2>
            <div className="w-24 h-0.5 bg-gray-400 dark:bg-gray-600 mx-auto mb-8"></div>
            <p className="text-gray-600 dark:text-gray-300">
              We proudly serve Maryland, DC, and Northern Virginia
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-4">Maryland</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Temple Hills</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Silver Spring</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Bethesda</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Rockville</span>
                </li>
              </ul>
            </div>
            
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-4">Washington DC</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Northwest DC</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Northeast DC</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Southwest DC</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Southeast DC</span>
                </li>
              </ul>
            </div>
            
            <div className="border border-gray-200 dark:border-gray-700 p-8">
              <h3 className="text-xl font-medium text-gray-800 dark:text-white mb-4">Northern Virginia</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Alexandria</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Arlington</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Fairfax</span>
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-gray-800 dark:text-gray-300" />
                  <span className="text-gray-600 dark:text-gray-300">Falls Church</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-800 dark:bg-gray-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-light mb-6">Ready for a Spotless Space?</h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Book your cleaning service today and enjoy a pristine environment. Satisfaction guaranteed!
          </p>
          <a
            href="/book"
            className="inline-block px-8 py-3 border-2 border-white hover:bg-white hover:text-gray-800 transition-colors"
          >
            Book Now
          </a>
        </div>
      </section>
    </div>
  );
}

export default About;